<!-- 
Dialog for changing a password.
-->
<template>
  <v-dialog :value="show" persistent content-class="dialog sm">
    <change-password-panel ref="panel" :dialog="true" @changed="hide" />
  </v-dialog>
</template>

<script>
import ChangePasswordPanel from "@/components/users/ChangePasswordPanel.vue";

export default {
  components: { ChangePasswordPanel },
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show(nowShowing) {
      if (nowShowing) {
        this.$refs.panel.clear();
      }
    }
  },
  methods: {
    hide() {
      this.$emit("update:show", false);
    }
  }
};
</script>
